// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import { InvoiceStateContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PageErrorWrapper, PageErrorWrapperStyles } from "@insite/content-library/Components/PageErrorWrapper";
import OrderLayout from "@store/Library/Components/Toolkit/Layout/OrderLayout";
import React, { useContext } from "react";

export interface InvoiceDetailsPageContainerStyles {
    pageErrorWrapper?: PageErrorWrapperStyles;
}

export const invoiceDetailsPageContainerStyles: InvoiceDetailsPageContainerStyles = {};

const styles = invoiceDetailsPageContainerStyles;

const InvoiceDetailsPageContainer = ({ id }: WidgetProps) => {
    const invoiceDataView = useContext(InvoiceStateContext);

    return (
        <PageErrorWrapper
            value={invoiceDataView}
            extendedStyles={styles.pageErrorWrapper}
            notFoundMessage={siteMessage("InvoiceHistory_Not_Found")}
        >
            <OrderLayout id={id} />
        </PageErrorWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: InvoiceDetailsPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Invoice History",
        allowedContexts: ["InvoiceDetailsPage"],
    },
};
export default widgetModule;
